import styled from '@emotion/styled';
import { media } from '@portalterreno/react-ui-core/Grid';

const Container = styled.div({
  [media('xs')]: {
    display: 'none'
  },
  [media('lg')]: {
    display: 'flex',
    alignItems: 'center'
  }
});

export default Container;
